import { ComponentLoader } from '@bythepixel/component-loader';
import DealerLocatorModal from './dealerLocatorModal';
import DealerLocatorMap from './dealerLocatorMap';
import DealerSearch from './dealerSearch';
import UseMyLocation from './useMyLocation';
import DealerList from './dealerList';

export default function initDealerLocator() {
  const modalEl = document.querySelector('[comp-dealer-locator-modal]');
  if (!modalEl) return;

  // Phase 1: Init modal, search, and map
  window.dealerLocator = new ComponentLoader(document, [
    DealerLocatorModal,
    DealerLocatorMap,
    DealerSearch,
    UseMyLocation,
  ], () => {
    // Phase 2: Init dealer list with map reference
    let map;
    window.dealerLocator.getRegistry().forEach((entry) => {
      if (!map && entry.instance instanceof DealerLocatorMap) {
        map = entry.instance;
      }
    });

    if (map) {
      window.dealerLocatorList = new ComponentLoader(document, [
        [DealerList, { map }],
      ]);
    }
  });
}
